package net.gorillagroove.sync

import net.gorillagroove.db.DbSyncStatus

val DbSyncStatus.isFirstSync get() = this.lastSyncedDown.toEpochMilliseconds() == 0L
